/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import './src/styles/global.css'
import * as Sentry from "@sentry/gatsby";
import { SENTRY_DSN } from "./src/utils/constants";

Sentry.init({
  dsn: SENTRY_DSN,
  environment: "production",
  initialScope: {
    tags: { app: "token-claiming" },
  },
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
});